
const axios = require('axios');

function initiateDesktopUpload(filename, mime_type, file_size, channel_id, total_parts, folder, is_vertical = false) {
  const config = {
    headers: {
      "access-token": localStorage.getItem('access-token'),
      pubid: localStorage.getItem('pub_id'),
      channelid: channel_id,
      role_id: localStorage.getItem('role_id')
    }
  };
  return axios.post(`${process.env.REACT_APP_API_SERVER_HOST}/desktopUpload/initiate`, {
    filename, mime_type, file_size, channel_id, total_parts, folder, is_vertical
  }, config).then(res => res.data);
}

function getDesktopUploadPresignedUrls(upload_id, part_numbers, channel_id) {
  const config = {
    headers: {
      "access-token": localStorage.getItem('access-token'),
      pubid: localStorage.getItem('pub_id'),
      channelid: channel_id,
      role_id: localStorage.getItem('role_id')
    }
  };
  return axios.post(`${process.env.REACT_APP_API_SERVER_HOST}/desktopUpload/presign`, {
    upload_id, part_numbers
  }, config).then(res => res.data);
}

function completeDesktopUpload(upload_id, parts, channel_id) {
  const config = {
    headers: {
      "access-token": localStorage.getItem('access-token'),
      pubid: localStorage.getItem('pub_id'),
      channelid: channel_id,
      role_id: localStorage.getItem('role_id')
    }
  };
  return axios.post(`${process.env.REACT_APP_API_SERVER_HOST}/desktopUpload/complete`, {
    upload_id, parts
  }, config).then(res => res.data);
}

function abortDesktopUpload(upload_id, channel_id) {
  const config = {
    headers: {
      "access-token": localStorage.getItem('access-token'),
      pubid: localStorage.getItem('pub_id'),
      channelid: channel_id,
      role_id: localStorage.getItem('role_id')
    }
  };
  return axios.post(`${process.env.REACT_APP_API_SERVER_HOST}/desktopUpload/cancel`, {
    upload_id
  }, config).then(res => res.data);
}

function getDesktopUploadStatus(upload_id, channel_id) {
  const config = {
    headers: {
      "access-token": localStorage.getItem('access-token'),
      pubid: localStorage.getItem('pub_id'),
      channelid: channel_id,
      role_id: localStorage.getItem('role_id')
    },
    params: { upload_id }
  };
  return axios.get(`${process.env.REACT_APP_API_SERVER_HOST}/desktopUpload/status`, config).then(res => res.data);
}

function listDesktopUploads(page = 1, limit = 20) {
  const config = {
    headers: {
      "access-token": localStorage.getItem('access-token'),
      pubid: localStorage.getItem('pub_id'),
      role_id: localStorage.getItem('role_id')
    },
    params: { page, limit }
  };
  return axios.get(`${process.env.REACT_APP_API_SERVER_HOST}/desktopUpload/list`, config).then(res => res.data);
}

function listDesktopUploadFolders(channel_id) {
  const config = {
    headers: {
      "access-token": localStorage.getItem('access-token'),
      pubid: localStorage.getItem('pub_id'),
      channelid: channel_id,
      role_id: localStorage.getItem('role_id')
    },
    params: { channel_id }
  };
  return axios.get(`${process.env.REACT_APP_API_SERVER_HOST}/desktopUpload/folders`, config).then(res => res.data);
}

function reportDesktopUploadFailure(upload_id, reason, channel_id) {
  const config = {
    headers: {
      "access-token": localStorage.getItem('access-token'),
      pubid: localStorage.getItem('pub_id'),
      channelid: channel_id,
      role_id: localStorage.getItem('role_id')
    }
  };
  return axios.post(`${process.env.REACT_APP_API_SERVER_HOST}/desktopUpload/fail`, {
    upload_id, reason
  }, config).then(res => res.data);
}

export const service = {
    initiateDesktopUpload,
    getDesktopUploadPresignedUrls,
    completeDesktopUpload,
    abortDesktopUpload,
    getDesktopUploadStatus,
    listDesktopUploads,
    listDesktopUploadFolders,
    reportDesktopUploadFailure,
}